(() => {
  const DEBUG = (() => {
    try {
      return window.localStorage && window.localStorage.DEBUG_CART_ATTRS === '1';
    } catch (error) {
      return false;
    }
  })();

  const FORM_IDS = ['cart', 'cart-drawer-form'];

  const readCookie = (name) => {
    const cookieString = document.cookie || '';
    if (!cookieString) return '';

    const parts = cookieString.split(';');
    for (let index = 0; index < parts.length; index += 1) {
      const part = parts[index].trim();
      if (!part.startsWith(`${name}=`)) continue;
      try {
        return decodeURIComponent(part.substring(name.length + 1));
      } catch (error) {
        return part.substring(name.length + 1);
      }
    }

    return '';
  };

  const getAttrValues = () => ({
    affId: readCookie('affid'),
    oid: readCookie('oid')
  });

  const buildAffInfo = (values) => JSON.stringify({
    affId: values.affId || '',
    oid: values.oid || ''
  });

  const updateDebugInputs = (values) => {
    const affInfo = buildAffInfo(values);
    ['attr-aff-info-drawer', 'attr-aff-info-cart'].forEach((id) => {
        const input = document.getElementById(id);
        if (input) input.value = affInfo;
    });
  };

  const isCheckoutControlInForm = (form) => {
    if (!form) return false;
    if (form.querySelector('input[name="checkout"]')) return true;
    if (form.querySelector('button[name="checkout"]')) return true;
    return false;
  };

  const isCheckoutPath = (urlString) => {
    if (!urlString) return false;
    try {
      const url = new URL(urlString, window.location.origin);
      return url.pathname === '/checkout' || url.pathname.startsWith('/checkout/');
    } catch (error) {
      return false;
    }
  };

  const debugLog = (...args) => {
    if (!DEBUG) return;
    console.log('[cart-attrs]', ...args);
  };

  const debugFetchCart = async () => {
    if (!DEBUG) return;
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      debugLog('cart.attributes', cart && cart.attributes ? cart.attributes : {});
    } catch (error) {
      debugLog('debug /cart.js failed');
    }
  };

  const ensureCartAttributes = async () => {
    const values = getAttrValues();
    updateDebugInputs(values);

    if (!values.affId && !values.oid) {
      debugLog('skip update: both cookies empty');
      return;
    }

    const affInfo = buildAffInfo(values);

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            aff_info: affInfo
          }
        })
      });
      await debugFetchCart();
    } catch (error) {
      debugLog('cart update failed');
    }
  };

  const handleFormSubmit = async (event) => {
    const form = event.target && event.target.closest ? event.target.closest('form') : null;
    if (!form || !FORM_IDS.includes(form.id)) return;
    if (!isCheckoutControlInForm(form)) return;
    if (form.dataset.cartAttrsSubmitting === '1') return;

    event.preventDefault();
    form.dataset.cartAttrsSubmitting = '1';
    await ensureCartAttributes();
    form.submit();
  };

  const findCheckoutHref = (eventTarget) => {
    if (!eventTarget || !eventTarget.closest) return null;

    const link = eventTarget.closest('a[href]');
    if (link && isCheckoutPath(link.getAttribute('href'))) {
      return link.getAttribute('href') || '/checkout';
    }

    const button = eventTarget.closest('button, input[type="submit"], input[type="button"]');
    if (button && button.formAction && isCheckoutPath(button.formAction)) {
      return button.formAction;
    }

    return null;
  };

  const handleCheckoutClick = async (event) => {
    const checkoutHref = findCheckoutHref(event.target);
    if (!checkoutHref) return;

    const trigger = event.target && event.target.closest
      ? event.target.closest('a[href], button, input[type="submit"], input[type="button"]')
      : null;
    if (trigger && trigger.dataset.cartAttrsSubmitting === '1') return;

    event.preventDefault();
    if (trigger) trigger.dataset.cartAttrsSubmitting = '1';

    await ensureCartAttributes();
    window.location.href = checkoutHref || '/checkout';
  };

  const init = () => {
    updateDebugInputs(getAttrValues());
    document.addEventListener('submit', handleFormSubmit, true);
    document.addEventListener('click', handleCheckoutClick, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ensureCartAttributesBeforeCheckout = ensureCartAttributes;
})();
